import { ResetPasswordForm } from '@features/user/profile/resetPasswordForm';
import { UserProfileForm } from '@features/user/profile/userProfileForm';
import { useProfile } from '@features/user/profile/useProfile';

export const ProfilePage = () => {
  const { onChangePassword } = useProfile();

  return (
    <div className="p-6">
      <UserProfileForm />
      <ResetPasswordForm onSubmit={onChangePassword} />
    </div>
  );
};
